// extracted by mini-css-extract-plugin
export default {"nft":"styles_nft__TlsiG","statusText":"styles_statusText__TaCrD","tableTitle":"styles_tableTitle__nxZuJ"};